<template>
  <esg-base-chart max-width="300px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart id="single-scope-emission-for-three-years"
                type="bar"
                ref="chart"
                height="250"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    scope: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        colors: [this.color],
        chart: {
          fontFamily: 'NanumGothic, serif',
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {  //=> bar option
          bar: {
            columnWidth: '50%',
            horizontal: false,
            dataLabels: {
              position: 'top'
            }
          },
        },
        xaxis: { //x 축
          categories: [],
          crosshairs: { show: false }
        },
        dataLabels: {
          enabled: true,
          formatter: val => this.formatNumber(val, 0),
          style: {
            fontFamily: 'NanumGothic',
            fontWeight: 'normal',
            colors: ['#000']
          },
          offsetY: -20
        },
        yaxis: {
          title: {
            text: '온실가스 배출량 (tCO2)',
            style: {
              fontSize: '12px',
              fontWeight: 'normal'
            },
          },
          labels: {
            formatter: val => this.compactFormatNumber(val)
          }
        },
        tooltip: {
          y: {
            show: true,
            formatter: val => {
              return this.formatNumber(val) + ' tCO2e'
            }
          },
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            if (dataPointIndex === 0) return null;

            const curr = series[seriesIndex][dataPointIndex];
            const prev = series[seriesIndex][dataPointIndex - 1];
            const diff = 100 * (curr - prev) / prev;
            const arrow = diff >= 0 ? '▲' : '▼';
            const abs = this.formatNumber(Math.abs(diff), 2);

            return `
              <div class="apexcharts-tooltip-box">
                <span>전년 대비 ${arrow} ${abs} %</span>
              </div>
            `
          }
        },
        grid: {
          show: false
        },
        legend: {
          position: 'right',
        },
      },
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let years = [year - 2, year - 1, year];
        let scopes = [this.scope];
        let args = [{
          years,
          scopes,
          groupKeys: ['year', 'scope'],
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }
        let list = JSON.parse(response.data.data)[0].data;

        this.setSeries(years, list);
        this.setLabels(years);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setSeries(years, list) {
      this.series.push({
        name: 'Scope ' + this.scope,
        data: list.map(row => row.values)
      })
    },
    setLabels(years) {
      this.chartOptions.xaxis.categories = years;
    }
  }
}
</script>

<style scoped>
>>> #single-scope-emission-for-three-years .apexcharts-bar-area[j="0"],
>>> #single-scope-emission-for-three-years .apexcharts-bar-area[j="1"] {
  opacity: .5;
}
</style>
